module.exports = __webpack_public_path__ + "static/media/日历14@2x.4f918d4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_145/img/日历14@2x.png
// module id = 1387
// module chunks = 0